import React from "react";
import { useParams } from "react-router-dom";
import { useGetTaskQuery } from "../../features/tasks/tasksApi";
import Form from "./Form";

const EditTask = () => {
  const { id } = useParams();
  const { data, isLoading, isError } = useGetTaskQuery(id, {
    skip: !id,
  });

  let content = null;
  // decide what to render
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong</div>;
  }
  if (!isLoading && !isError && data.id) {
    content = <Form key={data.id} task={data} />;
  }

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Edit Task for Your Team
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          {content}
        </div>
      </main>
    </div>
  );
};

export default EditTask;
